// Dev-only error logging; silenced in production builds to avoid leaking details.
export const logError = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.error(...args);
  }
};
